








import Vue from "vue";
import Overview from "./ConfigInfo/Overview.vue";

export default Vue.extend({
  name: "MonitorInfo",
  components: { Overview },
  data() {
    return {
      dialog: false,
      configData: null as any
    };
  },
  methods: {
    show(data: any) {
      const configData = JSON.parse(JSON.stringify(data));
      configData.listData = [];
      configData.name = configData.metadata.name;
      configData.createBy =
        configData.metadata.annotations &&
        configData.metadata.annotations["appmgr.object.createBy"];
      configData.description =
        configData.metadata.annotations &&
        configData.metadata.annotations["appmgr.object.description"];
      configData.createTime = configData.metadata.creationTimestamp;
      for (const key in configData.data) {
        configData.data[key] = configData.data[key].replace(/\\"/g, '"');
        configData.listData.push({ key, value: configData.data[key] });
      }
      this.configData = configData;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
});
